import { StaticQuery, graphql } from "gatsby";
import React from "react";

import { Image } from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import { PowerMove as PowerMoveComponent } from "components/PowerMove";

export const PowerMove = () => (
  <PowerMoveComponent>
    <StaticQuery
      query={graphql`
        query HowItWorksPowerMoveHeroImageQuery {
          file(relativePath: { eq: "house_model.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt="Someone constructing a model house"
          file={file}
          css={`
            + picture > img,
            img {
              object-position: 50% center;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 30% center;
              }
              @media screen and (min-width: ${getSize("tablet768")}) {
                object-position: 36% center;
              }
            }
          `}
        />
      )}
    />
  </PowerMoveComponent>
);
